<script>
  import ByPersonTrendChart from './ByPersonTrendChart.vue';

  export default {
    name: 'UnitTrends',
    extends: ByPersonTrendChart,
    data() {
      return {
        chartId: 'unitTrends',
        propertyName: 'net_units_sold',
        propertyNamePerson: 'net_ha_units',
        label: 'Net Units',
        curYearColor: '#39C2C9',
        prevYearColor: '#F6682F',
        labelFormat: ',.0f',
      };
    },
  };
</script>
